import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const SearchVideos = () => {

    const searchText = useParams();
    // console.log(searchText);

    const [allVideo, setAllVideo] = useState([]);
    // const [url, setUrl] = useState();
    useEffect(()=>{
        fetch(
          `https://youtube.googleapis.com/youtube/v3/search?part=snippet&channelId=UC49igY3A_M9__UL4_QUWTBA&order=date&maxResults=150&key=${process.env.REACT_APP_apiKey}`
        )
          .then((res) => res.json())
          .then((data) => setAllVideo(data?.items));
    },[])

    let url = [];
    allVideo?.forEach((data) => {
        const AllVideoTitle = data?.snippet?.title;
        const filter = AllVideoTitle.includes(searchText?.video);
        if (filter) {
            // console.log(AllVideoTitle);
            url = [...url,`https://www.youtube.com/embed/${data?.id?.videoId}`];
        };
    });
    return (
      <div className="grid  md:grid-cols-3 grid-cols-1 gap-4 mx-auto my-14 max-w-screen-xl">
        {url?.map((link) => {
          return (
            <div className="">
              <div className="card card-custom glass bg-slate-300">
                <figure>
                  <iframe
                    id="ytplayer"
                    type="text/html"
                    width="400"
                    height="220"
                    src={link}
                    title={"yt player"}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </figure>
                {/* <div className="card-body py-5 px-3 h-60">
                        <h2 className="card-title text-black">
                          {data?.snippet?.title}
                        </h2>
                        <p className="text-black">
                          {props.vdo.snippet?.description}
                        </p>
                      </div> */}
              </div>
            </div>
          );
        })}
      </div>
    );
};

export { SearchVideos };

